import { useState, useEffect } from "react";
import './profile.css';
import { Footer, NavbarUser, ProfileBasicInfo, ProfileQuestionnaire, Profileevents, Navbar } from '../../containers';
import api from '../../api/axios';
import { useTranslation } from 'react-i18next';

const Profile = () => {

    const { t } = useTranslation();
    const [userData, setUserData] = useState(null);
    const [bookedEvents, setBookedEvents] = useState([]);
    const [basicProgress, setBasicProgress] = useState({ count: 0, max: 0 });
    const [questionnaireProgress, setQuestionnaireProgress] = useState({ count: 0, max: 0 });
    const [pictureSrc, setPictureSrc] = useState(null);

    const progressCount = basicProgress.count + questionnaireProgress.count;
    const maxCount = basicProgress.max + questionnaireProgress.max;

    // Zustand für die Höhe der Navbar
    const [navbarUserHeight, setNavbarUserHeight] = useState(0);

    useEffect(() => {

        const storedLoginData = sessionStorage.getItem("userData");
        const storedToken = sessionStorage.getItem("token");
        if (storedLoginData && storedToken) {
            const parsedLoginData = JSON.parse(storedLoginData);
            setUserData(parsedLoginData);
        }

        // Bestimmen der Navbar-Höhe
        const navbarUserElement = document.querySelector('.navbarUser');
        if (navbarUserElement) {
            const navbarUserHeight = navbarUserElement.offsetHeight;
            setNavbarUserHeight(navbarUserHeight);
        }

        const fetchPicture = async () => {
            try {
                const pictureId = 22; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    }, []);

    // Second useEffect for dynamic updates (e.g., after form submission)
    useEffect(() => {
        if (userData) {
            sessionStorage.setItem('userData', JSON.stringify(userData));
        }
    }, [userData]);

    // Fetch booked events
    useEffect(() => {
        const fetchBookedEvents = async () => {
            try {
                const response = await api.post('/user/getbookedevents', {
                    userid: userData?.userid,
                    email: userData?.email,
                });
                setBookedEvents(response.data);
            } catch (error) {
                console.error("Error fetching booked events:", error);
            }
        };

        if (userData) {
            fetchBookedEvents();
        }
    }, [userData]);

    if (!userData) {
        return (
            <div>
                <Navbar></Navbar>
                <div>
                    <h2>{t('LogInToView')}</h2>
                </div>
                <Footer></Footer>
            </div>
        );
    }

    return (
        <>
            <div className="wrapper">
                <NavbarUser></NavbarUser>
                <div className="profile-background" style={{
                    backgroundImage: pictureSrc ? `url(${pictureSrc})` : 'none'
                }}>
                    <div className="profile-main" style={{ marginTop: navbarUserHeight + 5 }}>

                        {userData && <ProfileBasicInfo progressCount={progressCount}
                            maxCount={maxCount}
                            onProgressChange={(count, max) =>
                                setBasicProgress({ count, max })
                            } />}

                        {userData && <ProfileQuestionnaire progressCount={progressCount}
                            maxCount={maxCount}
                            onProgressChange={(count, max) =>
                                setQuestionnaireProgress({ count, max })
                            } />}

                        {userData && <Profileevents bookedEvents={bookedEvents} />}

                    </div>
                </div>
            </div>

            <Footer></Footer>
        </>
    )
}
export default Profile